/**
 * Governance Design Tokens
 *
 * Custom tokens for governance visualization components.
 * These are additive — they do not override Fluent UI theme tokens.
 * Regular pages continue using Fluent UI tokens; these are for
 * governance-specific visualizations (pipeline flows, graphs, control plane).
 *
 * The "governance teal/blue" dark-surface palette (#1FD2D3, #0F7FB3, #050C16,
 * #0F1B2D, #223044, #94A3B8) is a deliberate diagram-only accent scheme,
 * distinct from brand/brand-config.json's primary cyan — it has no brand-token
 * equivalent, so those values are left as raw literals to avoid changing the
 * visualizations' appearance. colorStatusSuccess/Error map exactly to the brand's
 * semantic success/error, so those are sourced from the theme; colorStatusWarning
 * (#F59E0B) does not exactly match the brand's warning (#E89652) and is left as-is.
 * colorGovernanceTextPrimary (always-white-on-dark) is sourced from Fluent's
 * static-inverted token, which is exactly white in both themes.
 */
import { tokens } from '@fluentui/react-components';
import { semanticColors } from '../../theme/solution-theme';

export const governanceTokens = {
  // Primary accent (governance teal)
  colorGovernancePrimary: '#1FD2D3',
  // Secondary (deep blue)
  colorGovernanceSecondary: '#0F7FB3',
  // Dark mode surfaces
  colorGovernanceBackground: '#050C16',
  colorGovernanceCardBg: '#0F1B2D',
  colorGovernanceDivider: '#223044',
  // Text
  colorGovernanceTextPrimary: tokens.colorNeutralForegroundStaticInverted,
  colorGovernanceTextSecondary: '#94A3B8',
  // Status
  colorStatusSuccess: semanticColors.success,
  colorStatusWarning: '#F59E0B',
  colorStatusError: semanticColors.error,
  colorStatusInfo: '#1FD2D3',
  // Pipeline
  colorPipelineConnector: '#1FD2D3',
  colorPipelineNode: '#0F7FB3',
  colorPipelineGlow: 'rgba(31, 210, 211, 0.5)',
  colorPipelineBlocked: semanticColors.error,
};
